import React from 'react';
import GridLayout from './GridLayout.jsx';
import ProductCard from './ProductCard.jsx';

export function ProductGrid({ products = [], columns = 3, ...props }) {
  return (
    <GridLayout columns={columns} gap="8" {...props}>
      {products.map((product) => (
        <ProductCard key={product.id || product.title} {...product} />
      ))}
    </GridLayout>
  );
}

export default ProductGrid;
